import script from "./head.vue?vue&type=script&setup=true&lang=js"
export * from "./head.vue?vue&type=script&setup=true&lang=js"

import "./head.vue?vue&type=style&index=0&id=c2ea887e&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ea887e"]])

export default __exports__